module.exports = __webpack_public_path__ + "img/ssclick-shop.6d2ff57a.png";